module.exports = __webpack_public_path__ + "static/media/human3.c3525a49.jpg";